import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'bpc-pos-print-ticket',
})
export default class PosPrintTicket extends Vue {
  @Prop({ type: Object, default: null }) readonly ticket;
  @Prop({ type: Array, default: [] }) readonly orderItems;
  @Prop({ type: String, default: null }) readonly posUserName: string;

  readyToShow = false;

  mounted() {
    this.printTicket();
  }

  destroyed() {
    const el = document.body;
    // Do not print the ticket if POS checkout not opened
    el.classList.remove('pos-checkout-opened');
  }

  async printTicket() {
    if (this.ticket && this.orderItems && this.posUserName) {
      this.readyToShow = true;
      const el = document.body;
      // Only print the ticket if POS checkout is opened
      el.classList.add('pos-checkout-opened');
      setTimeout(() => {
        document.title = '';
        window.print();
      });
    }
  }

  get logo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }
  get ticketHeader() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].ticket_header
      : null;
  }
  get ticketFooter() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].ticket_footer
      : null;
  }
  formatAmount(value: string) {
    if (!value) {
      value = '0';
    }
    if (typeof value === 'string') {
      value = value.replace(',', '');
    }
    return (
      parseFloat(value)
        .toFixed(2)
        .replace('.', ',') + ' €'
    );
  }
}
